const allFlavors = document.querySelectorAll('.Feed__Flavor');
const customFlavors = document.querySelectorAll('.Box__Flavors__Custom .Flavor');
const dragAndDropArea = document.getElementById('drag-and-drop');
const scrollDownButton = document.getElementById('scroll-button');
const productSectionLinks = document.querySelectorAll('.Box__Navigation .Button');
const subscriptionLink = document.getElementById('subscription-link');
const overlay = document.querySelector('.Overlay');
const step = ['first','second','third','fourth','fifth','sixth','seventh','eighth','ninth','tenth','eleventh','twelfth'];
const dragAndDrop = true;

const box = {
    isReady: false,
    section: document.querySelector('.Box'),
    container: document.querySelector('.Box__Flavors__Custom'),
    action: document.getElementById('custom-box-action'),
    upsell: document.getElementById('upsell-link'),
    flavors: [],
    max: customFlavors.length
}

const arrangeBox = () => {
    box.flavors.forEach((flavor,index) => {

        const flavorSource = document.getElementById(flavor);

        customFlavors[index].classList.add('Flavor--on');
        customFlavors[index].querySelector('p').innerHTML = flavorSource.dataset.flavor;
        customFlavors[index].querySelector('img').setAttribute('src',flavorSource.querySelector('img').src);
        customFlavors[index].querySelector('img').style.display = 'block';
        customFlavors[index].querySelector('input').setAttribute('value',flavorSource.dataset.flavor);
        customFlavors[index].querySelector('.Flavor__Remove').dataset.flavorIndex = index;
        customFlavors[index].querySelector('.Flavor__Remove').dataset.flavorId = flavor;
    });

    // update Box

    if(box.flavors.length === 0) {
        box.isReady = false;
        box.container.classList.remove('Box__Flavors__Custom--on');
        box.action.querySelector('span').innerHTML = step[0];
    }
    else if(box.flavors.length > 0 && box.flavors.length < box.max) {
        box.isReady = false;
        box.container.classList.remove('Box__Flavors__Custom--ready');
        box.container.classList.add('Box__Flavors__Custom--on');
        box.action.querySelector('span').innerHTML = step[box.flavors.length];
    }
    else if(box.flavors.length === box.max) {
        box.isReady = true;
        box.container.classList.remove('Box__Flavors__Custom--on');
        box.container.classList.add('Box__Flavors__Custom--ready');
    }
}

const resetBox = () => {
    customFlavors.forEach(flavor => {
        flavor.classList.remove('Flavor--on');
        flavor.querySelector('p').innerHTML = '';
        flavor.querySelector('img').removeAttribute('src');
        flavor.querySelector('img').style.display = 'none';
    });
}

const updateAllFlavors = () => {
    allFlavors.forEach(flavor => {
        (box.isReady) ? flavor.classList.add('Feed__Flavor--on-ready') : flavor.classList.remove('Feed__Flavor--on-ready');
    });
}

const updateBox = (selectedFlavorId,action,childIndex) => {

    let removalControl = false;

    switch(action) {
        case 'add':
            box.flavors.push(selectedFlavorId);
            break;
        case 'remove':
            box.flavors.forEach((flavor,index) => {
                if(flavor === selectedFlavorId && !removalControl) {
                    removalControl = true;
                    box.flavors.splice(index,1);
                }
            });
            resetBox();
        case 'removeSpecificChild':
            box.flavors.splice(childIndex,1);
            resetBox();
            break;
    }
    arrangeBox();
    updateAllFlavors();
    bodyUpdate(500);
}

const initInteraction = () => {
    
    // feed flavors

    allFlavors.forEach(flavor => {

        const countWrapper = flavor.querySelector('[data-count]');

        // add to box
        flavor.querySelectorAll('.Button--primary').forEach(action => {
            action.onclick = () => {
                if(!box.isReady) {
                    flavor.classList.add('Feed__Flavor--on');
                    updateBox(flavor.id,'add',1);
                }
            }
        })

        flavor.querySelector('.Button--remove').onclick = () => {            
            updateBox(flavor.id,'remove',1);
            // unselect flavor if the product is not repeated
            if(box.flavors.indexOf(flavor.id) === -1) {
                flavor.classList.remove('Feed__Flavor--on');
            }
        }

        // counter
        flavor.querySelectorAll('.Button--counter').forEach(button => {
            button.onclick = () => {

                let count = parseInt(countWrapper.dataset.count);
                
                // counter logic
                switch(button.dataset.action) {
                    case '+':
                        if(count < box.max) {
                            countWrapper.dataset.count = count + 1;
                            updateBox(flavor.id,'add');
                        }
                        break;
                    case '-':
                        if(count > 0) {
                            countWrapper.dataset.count = count - 1;
                            updateBox(flavor.id,'remove');
                        }
                        break;
                }
                
                // check if 0 and get back 
                if(flavor.querySelector('[data-count]').dataset.count == 0) {
                    flavor.classList.remove('Feed__Flavor--on');
                    countWrapper.dataset.count = 1;
                }
            }
        })

        // drag and drop 

        const dragAndDrop = true;

        if(dragAndDrop) {
            flavor.ondragstart = event => {
                event.dataTransfer.setData('text/plain',event.target.id);
                dragAndDropArea.classList.add('Box__DragAndDrop--on');
            };
    
            dragAndDropArea.ondragenter = event => {      
                dragAndDropArea.classList.add('Box__DragAndDrop--over');  
            };
    
            dragAndDropArea.ondragover = event => {    
                event.preventDefault();
                dragAndDropArea.classList.add('Box__DragAndDrop--over');
            };
            
            dragAndDropArea.ondragleave = event => {
                dragAndDropArea.classList.remove('Box__DragAndDrop--over'); 
            };
    
            flavor.ondragend = event => {
                dragAndDropArea.classList.remove('Box__DragAndDrop--on','Box__DragAndDrop--over'); 
            };
    
            dragAndDropArea.ondrop = event => {
                if(!box.isReady) {
                    const target = document.getElementById(event.dataTransfer.getData('text/plain'));
                    
                    target.classList.add('Feed__Flavor--on');
                    updateBox(target.id,'add',1);
                }
    
                setTimeout(() => {
                    dragAndDropArea.classList.remove('Box__DragAndDrop--on','Box__DragAndDrop--over'); 
                },50);
    
                event.preventDefault();
            };
        }
      
    });

    // box flavors

    customFlavors.forEach(flavor => {
        flavor.querySelector('.Flavor__Remove').onclick = event => {
            event.stopPropagation();
            updateBox(undefined,'removeSpecificChild',parseInt(event.target.dataset.flavorIndex));
            // update feed
            allFlavors.forEach(feedFlavor => {
                if(box.flavors.indexOf(feedFlavor.id) === -1) {
                    feedFlavor.classList.remove('Feed__Flavor--on');
                }
            });
            event.preventDefault();
        };
    });
    
    // scroll down 

    scrollDownButton.onclick = () => {
        return false;
    }

    // product links 

    productSectionLinks.forEach(link => {
        link.onclick = () => {
          
            // implementation with overlay  
            // overlay.dataset.target = link.dataset.target;
            // overlay.classList.add('Overlay--on');
            // document.body.style.overflowY = 'hidden';
          
            const target = document.querySelector(`[data-section-id="${link.dataset.contentTarget}"]`);
            const flavorFeed = document.querySelector('.Feed').getBoundingClientRect();
            const targetTop = Math.floor(flavorFeed.height);
          
            window.scrollTo({
                top: targetTop,
                behavior: 'smooth'
            });
        }
    });
  
    // subscription

    if(subscriptionLink) {
      subscriptionLink.onclick = event => {
          overlay.dataset.target = event.target.dataset.target;
          overlay.classList.add('Overlay--on','Overlay--subscription');
          document.body.style.overflowY = 'hidden';
          return false;
      }
    }

    // overlay

    overlay.querySelectorAll('[data-action="close"]').forEach(action => {
        action.onclick = () => {
            overlay.classList.remove('Overlay--on');
            document.body.style.overflowY = 'auto';
            setTimeout(() => {
                overlay.dataset.target = '';
            },500);
        }
    });

    // upsell link
  
    if(box.upsell) {
        box.upsell.onclick = () => {
    
            let newHref = box.upsell.getAttribute('href') + '?';
            
            box.flavors.forEach((flavor,index) => {
                newHref += (index > 0) ? '&' : '';
                newHref += encodeURIComponent('fl'+index+'=' + document.getElementById(flavor).querySelector('h3').innerHTML);
            });
    
            box.upsell.setAttribute('href',newHref);
            window.location = newHref;
    
            return false;
        }
    }
}

const stickyBox = () => {
    
    const boxProps = box.section.getBoundingClientRect();
    const wrapper = document.querySelectorAll('[data-section-id="product-custom-box-template"]')[0];

    // check if box is not visible
    if(document.documentElement.scrollTop > (boxProps.top + boxProps.height)) {
        wrapper.style.paddingTop = (boxProps.top + boxProps.height + 180 )+ 'px';
        box.section.classList.add('Box--sticky');
    }
    else {
        box.section.classList.remove('Box--sticky');
        wrapper.style.paddingTop = '0px';
    }
}

const bodyUpdate = interval => {
    setTimeout(() => {
        const boxProps =  box.section.getBoundingClientRect();
        document.body.style.paddingTop = (boxProps.height + boxProps.top) + 'px';
    },interval || 0);
}

const checkPresetParams = () => {

    let flavors = {};
    
    const vars = decodeURIComponent(window.location.href).replace(/[?&]+([^=&]+)=([^&]*)/gi,(m,key,value) => {
        flavors[key] = value;
    });
    
    for(let i=0; i<10; i++) {
        if(flavors['fl'+i]) {
            document.querySelectorAll('.Feed__Flavor').forEach(flavor => {
                if(flavor.querySelector('h3').innerHTML === flavors['fl'+i]) {
                    flavor.classList.add('Feed__Flavor--on');
                    updateBox(flavor.id,'add',1);
                }
            });
        }
    }
}

checkPresetParams();
initInteraction();
bodyUpdate();
window.onresize = () => bodyUpdate();

